<template>
  <base-dialog
    :title="`${isEditMode ? 'Update' : 'Create'} Event`"
    :action="onAction"
    :action-name="`${isEditMode ? 'Update' : 'Create'}`"
    :close="onClose"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-row>
        <v-col cols="12">
          <v-text-field
            outlined
            dense
            v-model="model.label"
            label="Event Label"
          />
          <v-text-field
            outlined
            dense
            v-model="model.description"
            label="Event Description"
          />
        </v-col>
      </v-row>
    </template>
  </base-dialog>
</template>

<script>
import { isEmpty } from 'lodash'
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"

export default {
  components: {
    BaseDialog
  },
  props: {
    event: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      isEditMode: false,
      model: {
        id: null,
        label: '',
        description: ''
      }
    }
  },
  watch: {
    event() {
      this.model = { ...this.event }
    }
  },
  mounted() {
    this.model = { ...this.event }
    this.isEditMode = !isEmpty(this.event.id)
  },
  methods: {
    ...mapActions([ 'createEvent', 'updateEvent' ]),
    resetModel() {
      this.model.id = null
      this.model.label = ''
      this.model.description = ''
    },
    async onAction() {
      const payload = { ...this.model }

      this.isEditMode
        ? await this.updateEvent(payload)
        : await this.createEvent(payload).then(() => { this.resetModel() })

    },
    async onClose() {

    },
    handleError(e) {
      const errMsg = e.response.data.message
      this.$store.commit('showSnack', { text: errMsg, color: 'error' })
    },
  }
}
</script>
